// extracted by mini-css-extract-plugin
export var buttonProvider = "styles-module--buttonProvider--3NWk8";
export var button = "styles-module--button--3FLfp";
export var transparent = "styles-module--transparent--2cVqA";
export var primary = "styles-module--primary--1q1RF";
export var greyscale = "styles-module--greyscale--2cqYu";